import { render } from "./LivescoringSC.vue?vue&type=template&id=afd16d5c&scoped=true"
import script from "./LivescoringSC.vue?vue&type=script&lang=js"
export * from "./LivescoringSC.vue?vue&type=script&lang=js"

import "./LivescoringSC.vue?vue&type=style&index=0&id=afd16d5c&scoped=true&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afd16d5c"]])

export default __exports__